import { gql, useQuery, useMutation } from "@apollo/client";
import { useState, useEffect } from "react";
import { captureException } from "@sentry/react";

import Challenge from "./Challenge";

export default ({ showNextPost }) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [optionClicked, setOptionClicked] = useState(null);
  const [showWrong, setShowWrong] = useState(false);

  // Fetch data
  const GET_CHALLENGE_DATA = gql`
    query GetChallengeData {
      challengeData {
        id
        type
        taskData
      }
    }
  `;

  const { loading, data, error, refetch } = useQuery(GET_CHALLENGE_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("fetching challenge data error", error);
    captureException(error);
  }

  const changeChallenge = () => {
    if (loadingSubmit) return;

    refetch();
  };

  const tryNewChallenge = () => {
    if (loadingSubmit) return;

    setOptionClicked(null);
    setShowWrong(false);
    refetch();
  };

  // handle Submit challenge
  const SUBMIT_CHALLENGE = gql`
    mutation SubmitChallenge($value: String!) {
      submitChallenge(value: $value) {
        resultCode
      }
    }
  `;

  const [submitChallenge] = useMutation(SUBMIT_CHALLENGE);

  const onSubmit = async (option) => {
    try {
      if (!data) return;
      if (loadingSubmit) return;

      setLoadingSubmit(true);
      setOptionClicked(option);

      const result = await submitChallenge({
        variables: {
          value: option.toString(),
        },
      });

      const { resultCode } = result.data.submitChallenge;

      console.log("resultCode", resultCode);

      if (resultCode !== 0) {
        // Challenge failed
        setLoadingSubmit(false);
        setShowWrong(true);

        return;
      }

      // Challenge passed, show new post
      showNextPost();

      setLoadingSubmit(false);
    } catch (error) {
      console.log("onSubmit error", error);
      captureException(error);
      setLoadingSubmit(false);
      return;
    }
  };

  console.log("data", data);

  return (
    <>
      {data && (
        <Challenge
          data={data}
          loading={loading}
          changeChallenge={changeChallenge}
          onSubmit={onSubmit}
          optionClicked={optionClicked}
          showWrong={showWrong}
          tryNewChallenge={tryNewChallenge}
        />
      )}
    </>
  );
};
